import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { Icon } from 'components/common/icons';

import type { CommonBlockPropsReader } from 'components/reader/blocks';

interface Props extends Pick<CommonBlockPropsReader<'discussion'>, 'fontSize'> {
  count: number;
  onClick: (args: { parentCommentId: number }) => void;
  parentCommentId: number;
  showReplies: boolean;
}

const ReaderBlockDiscussionToggleReplies = ({
  count,
  fontSize,
  onClick,
  parentCommentId,
  showReplies
}: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="toggle">
      <Button
        category="lighter"
        onClick={() => onClick({ parentCommentId })}
        size="small"
        text={
          <span>
            {showReplies
              ? messages.readerDiscussionHideReplies
              : messages.readerDiscussionShowReplies}

            <Icon
              icon={showReplies ? 'chevron-up' : 'chevron-down'}
              style={{
                fontSize: {
                  small: '1.1rem',
                  medium: '1.2rem',
                  large: '1.3rem',
                  huge: '1.5rem'
                }[fontSize],
                marginLeft: 5
              }}
            />
            <span className="count">{count}</span>
          </span>
        }
      />

      <style jsx>{`
        .count {
          background-color: white;
          border-radius: 20px;
          margin-left: 8px;
          margin-right: 2px;
          padding: 1px 6px;
        }
      `}</style>
    </div>
  );
};

export default ReaderBlockDiscussionToggleReplies;
